document.addEventListener('DOMContentLoaded', function () {
  // Quickview modal appended JS loading hack
  document.addEventListener('quickview:loaded', () => {
    const quickViewModals = document.querySelector('[data-is-quick-view]');
    const scripts = [...quickViewModals.querySelectorAll('script')];
    
    scripts.forEach((script) => {
      const parent = script.parentNode;
      const fragment = document.createRange().createContextualFragment(script.outerHTML);
      script.remove();
      parent.appendChild(fragment);
    })
  })
})